var map = {
	"./1.webp": 739,
	"./10.webp": 740,
	"./11.webp": 741,
	"./12.webp": 742,
	"./2.webp": 743,
	"./3.webp": 744,
	"./4.webp": 745,
	"./5.webp": 746,
	"./6.webp": 747,
	"./7.webp": 748,
	"./8.webp": 749,
	"./9.webp": 750,
	"./GG-Icon": 464,
	"./GG-Icon.png": 464,
	"./background": 751,
	"./background.png": 751,
	"./burger_menu": 465,
	"./burger_menu.png": 465,
	"./club.webp": 752,
	"./error-icon": 314,
	"./error-icon.svg": 314,
	"./log_out.webp": 753,
	"./player_profile.webp": 754,
	"./settings.webp": 755
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1334;